import {
  el,
  list,
  setChildren,
  setAttr,
  mount,
  unmount
} from 'redom';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import { stringToSVG } from 'utilities';

import './index.scss';

import squareIconString from 'assets/images/square-icon.svg?raw';
import circleIconString from 'assets/images/circle-icon.svg?raw';
import starIconString from 'assets/images/star-icon.svg?raw';
import triangleIconString from 'assets/images/triangle-icon.svg?raw';
import clipControlsIconString from 'assets/images/clip-controls-icon.svg?raw';

const clipControlsIcon = stringToSVG(clipControlsIconString);
const triangleIcon = stringToSVG(triangleIconString);
const starIcon = stringToSVG(starIconString);
const circleIcon = stringToSVG(circleIconString);
const squareIcon = stringToSVG(squareIconString);

export const clipTypes = {
  SQUARE: 'square',
  CIRCLE: 'circle',
  STAR: 'star',
  TRIANGLE: 'triangle'
};

const controls = [{
  type: clipTypes.SQUARE,
  icon: () => squareIcon.cloneNode(true),
  tooltip: 'Square clip'
}, {
  type: clipTypes.CIRCLE,
  icon: () => circleIcon.cloneNode(true),
  tooltip: 'Circle clip'
}, {
  type: clipTypes.STAR,
  icon: () => starIcon.cloneNode(true),
  tooltip: 'Star clip'
}, {
  type: clipTypes.TRIANGLE,
  icon: () => triangleIcon.cloneNode(true),
  tooltip: 'Triangle clip'
}];

class ClipControl {

  constructor(controls) {

    this.controls = controls;
    this.control = null;

    this.button = el('button.clip-control', {
      onclick: this.handleClick.bind(this)
    });
    this.el = el('x-tooltip', this.button);

  }

  handleClick(event) {

    setAttr(this.button, {
      disabled: true
    });

    this.controls.select(this.control);

    setAttr(this.button, {
      disabled: false
    });

  }

  update(control) {

    this.control = control;

    setChildren(this.button, [
      this.control.icon()
    ]);

    if (this.controls.isActive(this.control)) {
      this.el.classList.add('active');
    } else {
      this.el.classList.remove('active');
    }

    setAttr(this.el, { text: this.control.tooltip });

  }

}

class ClipControls {

  constructor(configuration) {

    this.clip = configuration.clip;
    this.onChange = configuration.onChange;
    this.hideTimeout = null;

    this.list = list('.clip-controls', ClipControl, 'type', this);

    this.list.update(controls);
    this.button = this.renderButton();
    this.el = el('.clip-controls-main', {
      onmouseenter: this.handleMouseEnter.bind(this),
      onmouseleave: this.handleMouseLeave.bind(this)
    }, [
      this.button
    ]);

  }

  handleMouseEnter() {

    if (this.hideTimeout !== null) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    mount(this.el, this.list);

    const element = this.list.el;
    const anchorElement = this.button;
    const viewportElement = void 0;
    const verticalOffset = 7;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top', 'bottom'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  handleMouseLeave() {

    this.hideTimeout = setTimeout(function delayedHide() {
      unmount(this.el, this.list);
      this.hideTimeout = null;
    }.bind(this), 350);

  }

  renderButton() {

    const options = {};

    if (typeof this.clip === 'string') {
      options.class = 'active';
    }

    const button = el('button.clip-control', options, clipControlsIcon.cloneNode(true));

    return button;

  }

  updateButton() {

    this.button.classList.remove('active');

    if (typeof this.clip === 'string') {
      this.button.classList.add('active');
    }

  }

  isActive(control) {

    return this.clip === control.type;

  }

  select(control) {

    if (this.clip === control.type) {
      this.clip = null;
    } else {
      this.clip = control.type;
    }

    this.updateButton();
    this.list.update(controls);

    this.onChange(this.clip);

  }

}

export default ClipControls;